module.exports = __webpack_public_path__ + "img/IMG_9519_L_Wood_MockedUp.3160d0a7.jpg";